module.exports = __webpack_public_path__ + "img/edit-gray-icon.adb36d33.svg";